import { AxiosRequestConfig } from "axios";
import { getToken, getEmployeeAlias } from "src/auth/cognito-auth";
import { getAftxToken, hasAftxCookie } from "src/auth/aftx-auth";
import { isAftxDomain } from "src/utils/aftx-utils";
import getMidwayToken from "src/common/axios/authentication/getMidwayToken";
import { isFcMenuDomain } from "src/utils/fc-utils";

const MIDWAY_TOKEN = "MidwayToken";

export default async function AxiosRequest(
  config: AxiosRequestConfig
): Promise<AxiosRequestConfig> {
  // Only get Midway token for non-AFTX domains
  if (!(isAftxDomain()||isFcMenuDomain())) {
    let midwayToken = sessionStorage.getItem(MIDWAY_TOKEN);
    if (midwayToken == null) {
      // TODO Add check for token expiry
      midwayToken = await getMidwayToken();
      sessionStorage.setItem(MIDWAY_TOKEN, midwayToken);
    }
    return {
      ...config,
      headers : {
        Authorization: getToken(),
        useralias: getEmployeeAlias()
      },
    }
  }
 // For AFTX requests
  return {
    ...config,
    // Include credentials to ensure cookies are sent with the request
    withCredentials: true
  };
}
